import functionCommon from "../common/function";
import CONSTANT from "../constant/constant";
import { leaveHolidayConstants } from "../constant/leaveHoliday.constants";
import { leaveHoliday } from "../services/leaveHoliday.service";

const _errorCode = CONSTANT.errorCode;
const emptyDataCode = CONSTANT.messageCode.emptyData;

export const getHolidayList = (data, isSearch = false, isPaging = false) => {
    const dayFormat = functionCommon.revertDateFormat(data.day);
    const params = {
        ...data,
        day: dayFormat,
    };
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        isPaging && dispatch(paging());
        isSearch && dispatch(searching());
        leaveHoliday.getHoliday(params).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    if (res.error_code === emptyDataCode) {
                        dispatch(success([]));
                    }
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(list) {
        return { type: leaveHolidayConstants.GET_HOLIDAY_LIST_SUCCESS, list };
    }
    function searching() {
        return { type: leaveHolidayConstants.GET_HOLIDAY_LIST };
    }
    function paging() {
        return { type: leaveHolidayConstants.GET_HOLIDAY_LIST_PAGE };
    }
};

export const createHoliday = (data, successParams = null) => {
    const dayFormat = functionCommon.revertDateFormat(data.day);
    const params = {
        ...data,
        day: dayFormat,
    };

    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(adding());
        leaveHoliday.createHoliday(params).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    if (successParams) {
                        leaveHoliday.getHoliday(successParams).then((res) => {
                            if (!res) return;
                            switch (res["http_code"]) {
                                case _errorCode.APISuccess:
                                    if (res.error_code === emptyDataCode) {
                                        dispatch(success([]));
                                    } else dispatch(success(res.result));
                                    break;
                                case _errorCode.TOKENExpired:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.APIInvalids:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.ClientNotPermission:
                                    functionCommon.logout();
                                    break;

                                default:
                                    window.location = "/error/404";
                                    break;
                            }
                        });
                    }
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    dispatch(failure(res["error_code"]));
                    break;
            }
        });
    };

    function success(newList) {
        return { type: leaveHolidayConstants.CREATE_HOLIDAY_SUCCESS, newList };
    }

    function adding() {
        return { type: leaveHolidayConstants.CREATE_HOLIDAY };
    }

    function failure(error) {
        return { type: leaveHolidayConstants.CREATE_HOLIDAY_FAIL, error };
    }
};

export const deleteHoliday = (data, successParams = null) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(deleting());
        leaveHoliday.deleteHoliday(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    if (successParams) {
                        leaveHoliday.getHoliday(successParams).then((res) => {
                            if (!res) return;
                            switch (res["http_code"]) {
                                case _errorCode.APISuccess:
                                    if (res.error_code === emptyDataCode) {
                                        dispatch(success([]));
                                    } else dispatch(success(res.result));
                                    break;
                                case _errorCode.TOKENExpired:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.APIInvalids:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.ClientNotPermission:
                                    functionCommon.logout();
                                    break;

                                default:
                                    window.location = "/error/404";
                                    break;
                            }
                        });
                    }
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(newList) {
        return { type: leaveHolidayConstants.DELETE_HOLIDAY_SUCCESS, newList };
    }
    function deleting() {
        return { type: leaveHolidayConstants.DELETE_HOLIDAY };
    }
};

export const updateHoliday = (data, successParams = null) => {
    const dayFormat = functionCommon.revertDateFormat(data.day);
    const params = {
        ...data,
        day: dayFormat,
    };
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(updating());
        leaveHoliday.updateHoliday(params).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    if (successParams) {
                        leaveHoliday.getHoliday(successParams).then((res) => {
                            if (!res) return;
                            switch (res["http_code"]) {
                                case _errorCode.APISuccess:
                                    if (res.error_code === emptyDataCode) {
                                        dispatch(success([]));
                                    } else dispatch(success(res.result));
                                    break;
                                case _errorCode.TOKENExpired:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.APIInvalids:
                                    functionCommon.logout();
                                    break;

                                case _errorCode.ClientNotPermission:
                                    functionCommon.logout();
                                    break;

                                default:
                                    window.location = "/error/404";
                                    break;
                            }
                        });
                    }
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    dispatch(failure(res["error_code"]));
                    break;
            }
        });
    };

    function success(newList) {
        return { type: leaveHolidayConstants.UPDATE_HOLIDAY_SUCCESS, newList };
    }
    function updating() {
        return { type: leaveHolidayConstants.UPDATE_HOLIDAY };
    }
    function failure(error) {
        return { type: leaveHolidayConstants.UPDATE_HOLIDAY_FAIL, error };
    }
};

export const clearMessageHoliday = () => {
    return (dispatch) => {
        dispatch({ type: leaveHolidayConstants.CLEAR_MESSAGE });
    };
};
